const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarRentedout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D4C41"
    },
    d: "M 13 37 C 13 36.445313 12.554688 36 12 36 L 9 36 C 8.445313 36 8 36.445313 8 37 L 8 42 C 8 42.554688 8.445313 43 9 43 L 12 43 C 12.554688 43 13 42.554688 13 42 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D4C41"
    },
    d: "M 40 37 C 40 36.445313 39.554688 36 39 36 L 36 36 C 35.445313 36 35 36.445313 35 37 L 35 42 C 35 42.554688 35.445313 43 36 43 L 39 43 C 39.554688 43 40 42.554688 40 42 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3F2FD"
    },
    d: "M 36 30 L 12 30 C 12 30 15.359375 21 16 20 C 16.640625 19 17.671875 19 18 19 C 18.160156 19 21.082031 19 25 19 C 29 19 30 19 30 19 C 30.214844 19 31.40625 18.96875 32 20 C 32.503906 20.875 36 30 36 30 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3D00"
    },
    d: "M 38 29 L 24 28 L 10 29 C 8.894531 29 8 29.894531 8 31 L 8 39 C 8 39.554688 8.445313 40 9 40 L 39 40 C 39.554688 40 40 39.554688 40 39 L 40 31 C 40 29.894531 39.105469 29 38 29 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3D00"
    },
    d: "M 30 20 C 30.339844 20 32.082031 20.132813 33.144531 22.753906 C 33.359375 23.273438 35.140625 27.742188 35.140625 27.742188 L 35.644531 29 L 12.355469 29 L 12.859375 27.738281 C 13.460938 26.226563 14.648438 23.238281 14.84375 22.769531 C 15.917969 20.199219 17.53125 20 18 20 L 30 20 M 30.003906 18 C 30.003906 18 30.003906 18 30 18 C 30 18 28 18 24 18 C 20.082031 18 18.160156 18 18 18 C 17.671875 18 14.667969 18 13 22 C 12.746094 22.609375 11 27 11 27 L 7 27 C 6.445313 27 6 27.445313 6 28 L 6 30 C 6 30.554688 6.445313 31 7 31 L 41 31 C 41.554688 31 42 30.554688 42 30 L 42 28 C 42 27.445313 41.554688 27 41 27 L 37 27 C 37 27 35.214844 22.523438 35 22 C 33.375 18 30.300781 18 30 18 C 29.996094 18 29.992188 18 29.992188 18 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M 38 35 C 38 35.554688 37.554688 36 37 36 L 11 36 C 10.445313 36 10 35.554688 10 35 L 10 32 C 10 31.445313 10.445313 31 11 31 L 37 31 C 37.554688 31 38 31.445313 38 32 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF176"
    },
    d: "M 14 33.5 C 14 34.328125 13.328125 35 12.5 35 C 11.671875 35 11 34.328125 11 33.5 C 11 32.671875 11.671875 32 12.5 32 C 13.328125 32 14 32.671875 14 33.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF176"
    },
    d: "M 37 33.5 C 37 34.328125 36.328125 35 35.5 35 C 34.671875 35 34 34.328125 34 33.5 C 34 32.671875 34.671875 32 35.5 32 C 36.328125 32 37 32.671875 37 33.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA000"
    },
    d: "M 33 11 L 20 11 L 20 7 L 25 7 L 25 9 L 27 7 L 29 7 L 29 9 L 31 7 L 33 7 L 35 7.996094 L 35 10 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA000"
    },
    d: "M 18 4 C 15.238281 4 13 6.238281 13 9 C 13 11.761719 15.238281 14 18 14 C 20.761719 14 23 11.761719 23 9 C 23 6.238281 20.761719 4 18 4 Z M 16 10 C 15.445313 10 15 9.554688 15 9 C 15 8.445313 15.445313 8 16 8 C 16.554688 8 17 8.445313 17 9 C 17 9.554688 16.554688 10 16 10 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D67C05"
    },
    d: "M 25 11 L 25 7 L 22.578125 7 C 22.847656 7.613281 23 8.285156 23 9 C 23 9.714844 22.847656 10.386719 22.578125 11 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarRentedout);
export default __webpack_public_path__ + "static/media/car-rentedout.1f502ce5120d5b914d8db67a48dafa89.svg";
export { ForwardRef as ReactComponent };